import type { ThemePreset } from "@/domain/tenant/brand";

/**
 * The organization's color preset is the only one: it is set on <html> (`data-theme-preset`, which
 * src/styles/presets/*.css key off) whenever the organization's branding loads or changes. It is also
 * remembered here so index.html can apply it before the first paint instead of flashing the default.
 */
export const THEME_PRESET_STORAGE_KEY = "gas-theme-preset";

export function applyThemePreset(preset: ThemePreset): void {
  document.documentElement.setAttribute("data-theme-preset", preset);
  try {
    localStorage.setItem(THEME_PRESET_STORAGE_KEY, preset);
  } catch {
    // storage unavailable — the preset still applies for this visit
  }
}
